import './DescargasPublicas.scss';
import { Col, Row, Spin } from 'antd';
import { FooterPortalPublico, HeaderPortalPublico } from 'components';
import {
  BuscadorDescargasPublicas,
  TablaDescargasPublicas
} from 'containers/PortalPublico/Descargas';
import { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getProcesosPublico } from 'actions/publicDownloads.actions';

const DescargasPublicas = () => {
  const dispatch = useDispatch();
  const [mainFilters, setMainFilters] = useState({});
  const seleccion = useRef({});
  const [showOverlay, setShowOverlay] = useState(true);
  const [catalogs, setCatalogs] = useState({});
  const initialized = useRef(false);

  const esperarCatalogos = async () => {
    // Se consultan los catálogos necesarios para la búsqueda
    if (!initialized.current) {
      initialized.current = true;
      const { success: scsProElect, response: respProElect } = await dispatch(
        getProcesosPublico(false)
      );

      const dataBD = { procesosElectorales: [] };
      if (scsProElect && respProElect?.data) {
        dataBD.procesosElectorales = respProElect.data || [];
      }
      setCatalogs(dataBD);

      setShowOverlay(false);
    }
  };

  useEffect(() => {
    esperarCatalogos();
  }, []);

  return (
    <>
      <HeaderPortalPublico />
      <div className="descargas-publicas">
        {showOverlay ? (
          <div className="descargas-loading">
            <div className="spinner-loading">
              <Spin size="large" />
            </div>
          </div>
        ) : (
          <div className="descargas-publicas-container">
            <div className="header-page">
              <Col>
                <Row span={18}>
                  <span className="title-label">
                    Resultados del Sistema Integral de Monitoreos de Actividades de Campo (SIMAC).
                  </span>
                </Row>
                <div>
                  El{' '}
                  <span className="bold-text">
                    Sistema Integral de Monitoreos de Actividades de Campo (SIMAC)
                  </span>
                  , contribuye a detectar anuncios espectaculares colocados en la vía pública y,
                  facilita la búsqueda de publicidad en medios impresos de circulación nacional y
                  local, para cotejar con los reportes de los aspirantes, precandidatos, candidatos
                  independientes y de partidos políticos y coaliciones.
                </div>
                <br />
                <span className="header-label">
                  Selecciona las opciones deseadas para realizar la búsqueda.
                </span>
              </Col>
            </div>
            <br />
            <BuscadorDescargasPublicas onSearch={setMainFilters} catalogos={catalogs} />
            <br />
            <TablaDescargasPublicas mainFilters={mainFilters} seleccion={seleccion} />
          </div>
        )}
      </div>
      <FooterPortalPublico />
    </>
  );
};

export { DescargasPublicas };
